
import { Vue } from 'vue-class-component';

export default class inputBreed extends Vue {
    // eslint-disable-next-line
    $store: any;

    get breed() {
        return this.$store.state.breed
    }

    set breed(value) {
        this.$store.commit('setBreed', value)
    }

    getBreed(){
        this.$store.dispatch('getBreed')
    }
}
